
import { ref, onMounted, computed, defineComponent, Component, h } from "vue";
import { useStore } from "vuex";
import { Actions, Mutations, Getters } from "@/store/enums/rootEnums";
import { MdPerson, IosMail } from "@vicons/ionicons4";
import {
  LogInOutline,
  LogOutOutline,
  Person,
  HelpCircle as HelpIcon
} from "@vicons/ionicons5";
import { useMessage, useThemeVars } from "naive-ui";
import { useRouter, useRoute } from "vue-router";
import { NIcon } from "naive-ui";
import invitePersonModel from "@/core/models/share/invitePerson.interface";

import { contentParticipantInfo as ExposedParticipantInfoI } from "@/core/models/share/content.interface";
import { apiExposedService as apiService } from '@/core/services/api/apiExposedService';

import {
  Module as ExposedModule,
  Actions as ExposedActions,
  Mutations as ExposedMutations,
  Getters as ExposedGetters
} from "@/store/enums/exposedEnums";
import { useI18n } from "vue-i18n";
const renderIcon = (icon: Component) => {
  return () => {
    return h(NIcon, null, {
      default: () => h(icon)
    });
  };
};
import { useDayjs } from '@/core/hook/useDayjs';
const { dayjs } = useDayjs();
import dayjsComponet from "@/components/share/dayjs.vue";

export default defineComponent({
  components: {
    MdPerson,
    LogInOutline,
    LogOutOutline,
    Person,
    IosMail,
    dayjsComponet
  },
  setup() {
    //const memberProfiles = ref([]);
    const store = useStore();
    // const router = useRoute();

    const route = useRoute();
    const Router = useRouter();

    //const ssoUser = computed(() => store.getters[Getters.SSO_USER]);
    const themeVars = useThemeVars();
    const i18n = useI18n();
    const checkedLang = ref(false);

    const userRes = computed(
      function() {
        let ori: ExposedParticipantInfoI =
          store.getters[
            ExposedModule.desc + ExposedGetters.EventPartRespStatus
          ];
        return { Name: ori.Member.Name };
      }
      // store.getters[
      // ExposedModule.desc +
      // ExposedGetters.EventPartRespStatus]
    );

    // const personNone = computed(
    //   // () => store.getters[HosterModule.desc + HosterGetters.InvitMember]
    //   function () {
    //     let ori: Array<invitePersonModel> = store.getters[ExposedModule.desc + ExposedGetters.InvitMember]
    //     ori = ori.filter(
    //       (r:invitePersonModel) => r.Status == ParamParticapantStatus.None
    //     );

    //   // var result = eventResponse.value.filter((e: voteEventModel) => e.EventScheduleId == eventScheduleId && e.Status != null)
    //   let name = ori.map((a:invitePersonModel) => a.Name).join(', ');
    //   let count = ori.length;

    //   return { name:name, count: count , data: ori};
    //   }
    // );

    if (
      route.query.State == "Reply" &&
      route.query.EventHeaderId != undefined
    ) {
      localStorage.setItem("State", "Reply");
      localStorage.setItem(
        "EventHeaderId",
        route.query.EventHeaderId.toString()
      );
    }

    // if (router.query.ParticipatantId != undefined && router.query.ParticipatantId != '') {
    //   //onOpenModal(router.query.ParticipatantId.toString())
    //   const participatantId = router.query.ParticipatantId.toString();
    //   store.dispatch(`${ExposedModule.desc}${ExposedActions.LoadExposed}`, { participatantId: participatantId })
    // }

    // if (ssoUser.value.isLoggedIn == false) {
    //   store.dispatch(Actions.SSO_LOGIN);
    // } else if (ssoUser.value.accessTokenExpired) {
    //   store.dispatch(Actions.VERIFY_AUTH);
    // }

    //store.dispatch(Actions.GET_User);

    function login() {
      store.dispatch(Actions.SSO_LOGIN);
    }

    function logout() {
      localStorage.removeItem("State");
      localStorage.removeItem("EventHeaderId");
      store.dispatch(Actions.SSO_LOGOUT);
    }

    onMounted(() => {
      getLang();
      // store.dispatch(Actions.VERIFY_AUTH);
      // if (ssoUser.value.isLoggedIn == false) {
      //   store.dispatch(Actions.SSO_LOGIN);
      // } else if (ssoUser.value.accessTokenExpired) {
      //   store.dispatch(Actions.VERIFY_AUTH);
      // }
    });
    const setLang = (lang: any) => {
      localStorage.setItem("lang", lang);
      i18n.locale.value = lang;
    };

    const getLang = () => {
      let lang = localStorage.getItem("lang");
      i18n.locale.value = lang || "tw";

      if (lang == "en") {
        checkedLang.value = true;
      } else if (lang == "tw") {
        checkedLang.value = false;
      }
    };

    const onChangeLang = (val: any) => {
      if (val == true) {
        setLang("en");
      } else if (val == false) {
        setLang("tw");
      }
      //console.log(val);
    };

    const onMenu = (val:{ label :string , url:string}) =>{
      onStatistics(val.label)
    }

    const onStatistics = (label: string) => {
      let id = '0';
      if (route.query.id) {
        id = route.query.id.toString()
        let data = new FormData();
        data.append('id', route.query.id.toString())
        data.append('category', label)
        apiService.getLog(data).then((res: any) => {
          console.log(res.data);
        })
      }
    }

    return {
      login,
      logout,
      //ssoUser,
      themeVars,
      options: [
        {
          label: "Help",
          key: "help",
          icon: renderIcon(HelpIcon)
        }
      ],
      handleSelect(key: string | number) {
        if (key == "help") {
          window.open(
            "https://wiki.realtek.com/pages/viewpage.action?pageId=279680115",
            "_blank"
          );
        }
      },
      userRes,
      setLang,
      checkedLang,
      onChangeLang,
      route,
      isOpen: ref(false),
      menuItems: [
      ],
       isActive(item:any) {},
       onMenu,
       onStatistics
    };
  }
});
